<template lang="pug">
section.dashboard
  h1.page-title Coaching Dashboard
  coaching-filter(
    :coachingFilters="coachingFilters"
    :applyFilters="applyFilters"
    :filtersChanged="filtersRemoved")
  patient-filter-tags(
    :patientFilters="coachingFilters"
    :applyFilters="removeFilters"
    :hasPatientFilters="hasCoachingFilters")
  .coaching-list-wrapper
    .coaching-entries
      patient-pagination(
        :initialPageSize="coachingDashboardSettings.pageSize"
        :initialPage="coachingDashboardSettings.page"
        :loading="coachingLoading"
        :changePage="applyPageSettings"
        :totalCount="coachingPatients.totalCount")
      coaching-list(
        :patients="coachingPatients.patients"
        :loading="coachingLoading"
        :selectPatient="doSelectPatient"
        :selectedPatientId="selectedPatientId")
      patient-pagination(
        :initialPageSize="coachingDashboardSettings.pageSize"
        :initialPage="coachingDashboardSettings.page"
        :loading="coachingLoading"
        :changePage="applyPageSettings"
        :totalCount="coachingPatients.totalCount")
    .coaching-snapshot
      coaching-snapshot(
        v-if="!coachingLoading && coachingPatientsLoaded && coachingPatients.patients && coachingPatients.patients.length > 0"
        :patient="selectedCoachingPatient"
        :patientCoachingData="selectedPatientData"
        :loading="patientDetailsLoading"
        :markReviewed="markPatientAsReviewed")
</template>
<script>
import CoachingList from './coaching/CoachingList.vue';
import CoachingSnapshot from './coaching/CoachingSnapshot.vue';
import CoachingFilter from '@/components/patient/CoachingFilter.vue';
import PatientFilterTags from '@/components/patient/PatientFilterTags.vue';
import PatientPagination from '@/components/patient/PatientPagination.vue';

import _ from 'lodash';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'Coaching',
  components: {
    CoachingList,
    CoachingFilter,
    PatientFilterTags,
    PatientPagination,
    CoachingSnapshot
  },
  data() {
    return {
      coachingPatientsLoaded: false,
      selectedPatientId: 0,
      filtersRemoved: false,
      selectedPatientData: {}
    };
  },
  computed: {
    selectedCoachingPatient() {
      return this.getPatientDetailsById(this.selectedPatientId);
    },
    usersCoachId() {
      if (!this.user.id || !this.coaches || this.coaches.length < 1) {
        return null;
      }
      return this.coaches.filter(item => item.userId === this.user.id)[0]['id'];
    },
    ...mapGetters([
      'getPatientDetailsById',
      'patientDetailsLoading',
      'coaches',
      'coachingLoading',
      'coachingPatients',
      'coachingFilters',
      'hasCoachingFilters',
      'coachingDashboardSettings',
      'user',
      'isCoachSupervisor',
      'usersCoachId'
    ])
  },
  methods: {
    applyPageSettings(settings) {
      this.setCoachingDashboardSettings(settings);
      this.selectedPatientId = 0;
      this.getCoachingPatients();
    },
    doSelectPatient(patient) {
      this.selectedPatientData = patient;
      this.selectedPatientId = patient.id;
      this.setPatientSnapshotId(patient.id);
      this.getPatientDetails(patient.id);
    },
    doMarkPatientAsReviewed(patientId) {
      this.markPatientAsReviewed(patientId).then(() => {
        this.getPatientList();
      });
    },
    removeFilters(filters) {
      this.filtersRemoved = true;
      this.setCoachingFilters({
        filters,
        isCoachSupervisor: this.isCoachSupervisor,
        usersCoachId: this.usersCoachId
      });
    },
    applyFilters(filters) {
      this.setCoachingFilters({
        filters,
        isCoachSupervisor: this.isCoachSupervisor,
        usersCoachId: this.usersCoachId
      });
      this.setCoachingDashboardSettings({ page: 1 });
      if (this.filtersRemoved && !this.hasCoachingFilters) {
        this.getCoachingPatients().then(() => {
          this.reset();
        });
      } else {
        this.delayedRefresh();
      }
    },
    delayedRefresh() {
      this.getCoachingPatients().then(() => {
        this.reset();
      });
    },
    reset() {
      this.coachingPatientsLoaded = true;
      this.filtersRemoved = false;
      this.selectedPatientId = 0;
      this.setPatientSnapshotId(0);
    },
    ...mapMutations([
      'setPatientSnapshotId',
      'setCoachingFilters',
      'setCoachingDashboardSettings'
    ]),
    ...mapActions([
      'getCoaches',
      'getCoachingPatients',
      'getPatientDetails',
      'markPatientAsReviewed'
    ])
  },
  created() {
    this.getCoaches().then(() => {
      // Timeout to avoid race condition
      // where store data not yet set by the time this action is fired
      setTimeout(() => {
        this.getCoachingPatients().then(() => {
          this.coachingPatientsLoaded = true;
        });
      }, 500);
    });

    // add delay before refreshing
    this.delayedRefresh = _.debounce(this.delayedRefresh, 1000);
  }
};
</script>

<style lang="scss" scoped>
.coaching-list-wrapper {
  display: flex;
  justify-content: space-between;
}
.coaching-entries {
  width: 78%;
}
.coaching-snapshot {
  width: 20%;
  position: relative;
}
</style>
